<template>
	<div id="">
		<div class="">
			<img :src="advertimages.imgurl" />
		</div>
		<div class="article_list">
			<div class="article_show" :class="nav_index==index?'nav_default_cli':'nav_default'" v-for="(item,index) in nav" @click="nav_cli(item,index,item.inde)">
				<div>{{item.name}}</div>
				<div class="border_bottom" v-show="item.show"></div>
			</div>
		</div>
		<div class="">
			<div class="article_item" v-for="item in articles" @click="art(item.articleid)">
				<div class="article_item_one">
					<div class="article_item_text">{{item.title}}</div>
					<div class="article_item_txt">{{item.pubtime}}</div>
				</div>
				<div class="article_item_tew">
					<img :src="item.imgurl" />
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'PersonalCenter',
		data() {
			return {
				nav: [],
				baseUrl: "",
				baseUrlo: "",
				orderlist: "",
				inde: '10',
				articles: [],
				index: 0,
				advertimages: [],
				nav_index: 0
			}
		},
		methods: {
			nav_cli(item, index, inde) {
				var that = this;
				that.inde = inde;
				that.index = index;
				that.nav_index = index;
				sessionStorage.setItem('index', index)
				var categoryid = item.categoryid
				sessionStorage.setItem('categoryid', categoryid)
				that.article(categoryid)
			},
			art(e) {
				var that = this
				var querytype = this.$route.query.type;
				if(querytype == "ios") {
					window.webkit.messageHandlers.OnLineCollectionFun.postMessage({
						pushID: e
					});
				} else if(querytype == "android") {
					web.OnLineCollectionFun(
						"{'pushID':" + e + "'}"
					);
				} else {
					// 无
					sessionStorage.setItem("articleid", e);
					that.$router.push({
						name: 'Articleitem',
						query: {
							articleid: e
						}
					});
				}

			},
			advertPlacement() {
				var that = this
				wclient.view.showLoading();
				that.$http.get(that.baseUrl + '?ugi=advertPlacement&action=selectAdvertPlacement&moduleid=PORTAL&apid=81a43c3ab99e4e908237b9552984ad0d', {

					})
					.then(function(res) {
						wclient.view.hideLoading();
						that.advertimages = res.data.adverplacement.advertimages[0];

					})
					.catch(function(err) {
						console.log(err);
					});
			},
			ticketactivity() {
				var that = this
				wclient.view.showLoading();
				that.$http.get(that.baseUrlo + '?ugi=ticketactivity&action=getActivityList&moduleid=TICKETS&categoryid=90dec8d3b36e412495465b49a0f02fb0&sponsorid=a0df565fe509435eba413105fc9a006c', {

					})
					.then(function(res) {
						wclient.view.hideLoading();
						that.articles = res.data.activitylist;

					})
					.catch(function(err) {
						console.log(err);
					});
			},
			article(e) {
				var that = this
				wclient.view.showLoading();
				that.$http.get(that.baseUrl + '?ugi=article&action=listbycategory&moduleid=PORTAL&categoryid=' + e, {

					})
					.then(function(res) {
						wclient.view.hideLoading();
						that.articles = res.data.articles;

					})
					.catch(function(err) {
						console.log(err);
					});
			}

		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrlo = "http://tickets.xs.weapi.org/tickets/tickets/ajax";
				var baseUrl = "http://xs.weapi.org/ajax";
				that.nav = [{
					"name": "最新资讯",
					"categoryid": 'b837902591fd4dd3b990c9c4177fcf92'
				}, {
					"name": "展览资讯",
					"categoryid": 'f5966aa38b034a35a02b7d13b1ce3491'
				}, {
					"name": "活动讲座",
					"categoryid": 'bf18d20938e541b789d323b2f0d51de8'
				}]
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrlo = "http://tickets.xs.weapi.org/tickets/tickets/ajax";
				var baseUrl = "http://xs.weapi.org/ajax";
				that.nav = [{
					"name": "最新资讯",
					"categoryid": 'b837902591fd4dd3b990c9c4177fcf92'
				}, {
					"name": "展览资讯",
					"categoryid": 'f5966aa38b034a35a02b7d13b1ce3491'
				}, {
					"name": "活动讲座",
					"categoryid": 'bf18d20938e541b789d323b2f0d51de8'
				}]
			} else {
				var baseUrlo = "https://www.xiangshan1949.cn/tickets/tickets/ajax";
				var baseUrl = "https://www.xiangshan1949.cn/ajax";
				that.nav = [{
					"name": "最新资讯",
					"categoryid": 'b837902591fd4dd3b990c9c4177fcf92'
				}]
			}
			that.baseUrl = baseUrl;
			that.baseUrlo = baseUrlo;
			if(sessionStorage.getItem('categoryid') == null) {
				var categoryid = 'b837902591fd4dd3b990c9c4177fcf92'
				that.article(categoryid)
			} else {
				that.article(sessionStorage.getItem('categoryid'))
				that.nav_index = sessionStorage.getItem('index')
			}
			wclient.view.showLoading();
			that.advertPlacement()
		}
	}
</script>

<style scoped>
	.article_list {
		width: 85%;
		display: flex;
		justify-content: space-around;
		margin: 0 auto;
		color: #949399;
		font-size: 16px;
	}
	
	.article_show {
		width: 33%;
		text-align: center;
		margin: 10px;
	}
	
	.nav_default_cli {
		color: #CF120E;
		font-size: 18px;
	}
	
	.border_bottom {
		width: 50%;
		border-bottom: 2px solid rgba(207, 18, 14, 1);
		margin-left: 25%;
		margin-top: 3px;
	}
	
	.article_item {
		width: 90%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		padding: 8px 0;
		border-bottom: 1px #F2F3F5 solid;
	}
	
	.article_item_one {
		width: 62%;
	}
	
	.article_item_tew {
		width: 118px;
		height: 86px;
		border-radius: 5px;
		overflow: hidden;
	}
	
	.article_item_tew img {
		width: 100%;
		height: auto;
	}
	
	.article_item_text {
		font-size: 17px;
		color: #191F25;
		font-weight: bold;
		line-height: 22px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}
	
	.article_item_txt {
		font-size: 12px;
		color: #ACB4BB;
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/article.vue